module.exports = __webpack_public_path__ + "static/media/curbside.23da4f33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/login/marketing/curbside.jpg
// module id = 13893
// module chunks = 0